import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import moment from "moment";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";

const ContestPrizes = () => {
  const { setError } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [contentDetail, setContentDetail] = useState<any>(null);
  const [selectedFilterType, setSelectedFilterType] = useState("date");

  const getContentData = () => {
    setLoading(true);
    const sort_by = selectedFilterType === "date" ? "asc" : "desc";
    axios({
      URL: `/omw/get-content?sort_order=${sort_by}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setContentDetail(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (selectedFilterType) {
      getContentData();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterType]);

  return (
    <ContentLayout className={"items-start"}>
      <div className="w-full flex justify-between px-8 flex-wrap gap-2">
        <p className={"text-3xl font-bold text-secondary underline"}>
          Contests
        </p>
        <div className="relative inline-block text-left">
          <select
            className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            onChange={(e) => setSelectedFilterType(e.target.value)}
          >
            <option value="date">Date</option>
            <option value="alphabetical">Alphabetical</option>
            <option value="popularity">Popularity</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M5.516 7.548L10 12.032l4.484-4.484L16.017 8 10 14.018 3.983 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div className="bg-white w-full mt-8">
        <div className={"mt-4 w-full px-14"}>
          <div
            className={
              "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4"
            }
          >
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold truncate"}>
                {contentDetail?.most_played_content_name || "-"}
              </p>
              <p className={"text-white text-xl truncate"}>
                Most Played Content Name
              </p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold truncate"}>
                {contentDetail?.most_played_content_id || 0}
              </p>
              <p className={"text-white text-xl truncate"}>
                Most Played Content Id
              </p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold"}>
                {contentDetail?.most_played_count || 0}
              </p>
              <p className={"text-white text-xl"}>Most Played Count</p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold"}>
                {contentDetail?.total_winners || 0}
              </p>
              <p className={"text-white text-xl"}>Total Win</p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold"}>
                {contentDetail?.total_played || 0}
              </p>
              <p className={"text-white text-xl"}>Total Played</p>
            </div>
          </div>
        </div>
        <div className="m-8">
          <div className="container center p-4 mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {contentDetail &&
                [...contentDetail?.contests]?.map(
                  (card: any, index: number) => {
                    return (
                      <div
                        className="w-full max-w-sm sm:max-w-full md:max-w-sm rounded-lg overflow-hidden shadow-xl bg-white"
                        key={`Contest_${index}`}
                      >
                        <div className="relative">
                          <img
                            className="w-full h-64 object-cover"
                            src={card?.content_image}
                            alt="Contest"
                          />
                          <div className="absolute inset-0 bg-black opacity-40"></div>
                          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-transparent to-transparent p-4">
                            <div className="relative z-10 text-white">
                              <h2 className="text-xl font-semibold">
                                {card?.content_name}
                              </h2>
                              <hr className="border-t-2 border-gray-300 my-2" />
                              <p className="text-sm mb-2">
                                {card?.content_subtitle +
                                  card?.content_description}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="py-4 px-4">
                          <div className="flex flex-col">
                            <div className="flex items-center mb-2">
                              <span className="font-semibold text-lg">
                                Total Plays:
                              </span>
                              <span className="ml-2 text-lg">
                                {card?.times_played}
                              </span>
                            </div>
                            <div className="flex items-center mb-2">
                              <span className="font-semibold text-lg">
                                Winners:
                              </span>
                              <span className="ml-2 text-lg">
                                {card?.total_winners}
                              </span>
                            </div>
                            <div className="flex items-center mb-2">
                              <span className="font-semibold">Amount:</span>
                              <span className="ml-2">
                                {card?.content_amount}
                              </span>
                            </div>{" "}
                            <div className="flex items-center mb-2">
                              <span className="font-semibold">
                                Created Date:
                              </span>
                              <span className="ml-2">
                                {moment(card?.created_dt).format("DD-MM-YYYY")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default ContestPrizes;
